<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Выбор приоритетной продукции:</label>
      </p>

      <Multiselect
        label="LABEL"
        class="i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
        :limit="200"
        :limitText="filterItemText"
        track-by="ID"
        v-model="
          $parent.project.SETTING_TABLE.allData
            .UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID
        "
        :disabled="$parent.$parent.projectDisabled"
        :options="filterMVKList"
        :multiple="true"
        placeholder
      />

      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_LIST_PRIORITY_PRODUCTS_FORMED_MVK_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { FETCH_DIRECTORIES } from "../../../../store/actions.type";

export default {
  name: "criticalCompMVK",
  components: {
    Multiselect
  },
  computed: {
    filterMVKList() {
      let version =
        ( this.$parent.project.UF_SETTING.VERSION_LIST_PRIORITY_PRODUCTS_FORMED_MVK &&
          parseInt(this.$parent.project.UF_SETTING.VERSION_LIST_PRIORITY_PRODUCTS_FORMED_MVK) > 0
        )
          ? parseInt(this.$parent.project.UF_SETTING.VERSION_LIST_PRIORITY_PRODUCTS_FORMED_MVK)
          : 1;

      let t = this.$parent.directory.sp_list_priority_products_formed_mvk.filter(el =>
        el.VERSIONS.includes(version)
        //this.in_array(version, el.VERSIONS)
      );
      if (t.length > 0) {
        return t;
      }

      return [];
      //return this.$parent.directory.sp_list_priority_products_formed_mvk;
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "sp_list_priority_products_formed_mvk"
    ]);
  },
  methods: {
    changeOption() {
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_CRITICAL_COMP_MVK_ID"
      );
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    }
  }
};
</script>

<style scoped></style>
